// src/data/Updates.js
export const updates = [
    {
    date: "2026-01-03",
    type: "new",
    description: "Danzō's Kaigishitsu",
    chapterSlug: "aftermath/danzoskaigishitsu"
  },
  {
    date: "2026-01-03",
    type: "new",
    description: "The Wind of Renewal",
    chapterSlug: "aftermath/thewindofrenewal"
  },
  {
    date: "2025-12-29",
    type: "article",
    description: "Why Naruto: Saihen?",
    articleSlug: "whynarutosaihen"
  },
    {
    date: "2025-12-28",
    type: "bugfix",
    description: "Fixed broken urls"
  },
  {
    date: "2025-12-21",
    type: "new",
    description: "What Won't Die",
    chapterSlug: "whatwontdie"
  },
  {
    date: "2025-12-15",
    type: "new",
    description: "The Forest of Death: Day 1",
    chapterSlug: "theforestofdeath/day1"
  }

];
